import { useState } from "react";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import CommonModal from "../../../Components/Modals/CommonModal"; // For the Errors modal
import Table, { Column } from "../../../Components/Tables/Table";
import { failedOrdersData } from "../../../Data/outbound";
import FailedOrdersDetailsLayout from "../../../Layout/FailedOrdersDetailsLayout";
import PageHeader from "../../../Layout/PageHeader";

const FailedOrders = () => {
  const pageName = "Failed Orders";
  const [showRowClicked, setShowRowClicked] = useState(false);
  const [showConfModal, setShowConfModal] = useState(false);
  const [showErrorsModal, setShowErrorsModal] = useState(false);
  const [currentErrorDetails, setCurrentErrorDetails] = useState<string | null>(
    null
  );

  const handleConfShow = () => setShowConfModal(true);
  const handleConfClose = () => setShowConfModal(false);

  const handleErrorsClick = (data: { errors: string }) => {
    setCurrentErrorDetails(data.errors);
    setShowErrorsModal(true);
  };
  const handleErrorsModalClose = () => setShowErrorsModal(false);

  const handelDownloadScreenAction = (data: any) => {};
  const handelDeleteAction = (data: any) => setShowConfModal(true);

  const onCurrentPageChange = (page: number) => {
    console.log("Page changed to:", page);
  };

  const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleConfClose();
  };

  const columns: Column[] = [
    {
      name: "Title",
      selector: (row: { title: string }) => row.title,
    },
    {
      name: "Date Upload",
      selector: (row: { dateUploaded: string }) => row.dateUploaded,
    },
    {
      name: "Created By",
      selector: (row: { createdBy: string }) => row.createdBy,
    },
    {
      name: "Errors",
      selector: (row: { errors: string }) => (
        <a
          className="cursor-pointer text-danger fs-14"
          onClick={() => handleErrorsClick(row)}
        >
          {row.errors}
        </a>
      ),
    },
    {
      name: (
        <>
          <ArrowLeftRight className="me-2" /> <PlusCircle />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={() => setShowRowClicked(true)}
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDownloadScreenAction(row)}
            >
              Download
            </li>
            <li
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDeleteAction(row)}
            >
              Delete
            </li>
          </ul>
        </>
      ),
    },
  ];

  return (
    <>
      <PageHeader
        listUrl="/outbound/orders"
        viewType={true}
        isHistoryEnabled={true}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div>
        <Table
          columns={columns}
          data={failedOrdersData}
          pagination={{
            recordsPerPage: 15,
            totalRecords: failedOrdersData.length,
            onCurrentPageChange,
          }}
          CheckboxStatus={true}
          enableSorting={true}
        />
      </div>
      <CommonConfirmationModal
        customClassName="header-border"
        show={showConfModal}
        content={
          <>
            You are about to delete this failed order <br />
            Are you sure?
          </>
        }
        onModalSubmit={onModalSubmit}
      />
      <CommonModal
        handleClose={handleErrorsModalClose}
        show={showErrorsModal}
        heading="Order Errors"
        content={
          <FailedOrdersDetailsLayout handleClose={handleErrorsModalClose} />
        }
        modalSize="modal-lg"
        customClassNameForTitle="text-danger"
        customClassNameForHeader="pb-0"
        customClassnameForHr="m-0 d-none"
        customClassNameForBody="fixed-height-500 overflow-auto narrow-scroll"
        footerButtonsActive={false}
      />
    </>
  );
};

export default FailedOrders;
